<template>
<!-- 测评答题 -->
  <div class="evaluation-detail">
    <div class="answer-section">
      <p class="test-title">{{testName}}</p>
      <p class="test-arrow m-t-10"><i class="el-icon-arrow-down"></i></p>
      <p class="test-schedule m-t-10"><span>测评进度</span> <span>{{currentIndex+1}}</span><span>/</span><span>{{questionBank.length}}</span>
      </p>
      <div class="test-section">
        <p class="topic">
          <span>{{currentIndex+1}}、</span>
          <span>{{currentQuestion.topicLibraryName}}</span>
        </p>
        <div class="options-box p-t-10" :class="{'color-main': topicItem.isCheck}"
             v-for="(topicItem, topicIndex) in currentQuestion.options"
             @click="handleTopic(topicIndex)">
          <div class="option-content">
            {{topicItem.optionName}}
          </div>
          <div class="option-choose" :class="{'checked': topicItem.isCheck}" v-if="topicItem.isCheck">
            <i class="el-icon-check"></i>
          </div>
          <div class="option-choose" v-else>
          </div>
        </div>
      </div>
      <div class="test-operate">
        <el-button :disabled="currentIndex==0" @click="switchTopic(-1)">上一题</el-button>
<!--        <el-button type="primary" round v-if="currentIndex != questionBank.length-1"-->
<!--                   @click="switchTopic(1)">下一题-->
<!--        </el-button>-->
        <el-button v-if="currentIndex == questionBank.length-1" type="primary" @click="getStudentInfo">提交</el-button>
      </div>
    </div>
    <div class="right-btn-box">
      <el-button style="background-color: #f96630;" circle @click="goBack()">返回</el-button>
    </div>
    <!--  手机学生信息  -->
    <el-dialog title="测评报告生成" :visible.sync="dialogStudent" width="500px">
      <el-form style="padding: 0 30px;" :model="studentForm" label-width="75px" label-position="left">
        <el-form-item label="姓名" required>
          <el-input v-model.trim="studentForm.stuName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="学校" required>
          <el-input v-model.trim="studentForm.schoolName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="手机号" required>
          <el-input v-model.trim="studentForm.phone" autocomplete="off" :maxlength="11"></el-input>
        </el-form-item>
        <el-form-item label-width="0">
          <div class="text-left" style="line-height: 22px; color: #f00">特别提醒：如果您以前已在本平台做过该测评，“确定”后，本次测评结果将会覆盖过往测评记录，请确认好后再确定!</div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer text-center">
        <el-button @click="dialogStudent = false">取 消</el-button>
        <el-button type="primary" @click="submitStudentInfo">确 定</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
import { request } from "@/util/request"

export default {
  name: "evaluationAnswer",
  data () {
    return {
      fullscreenLoading: true,
      radio: 1,
      testId: '',
      testName: "",
      questionBank: [],
      currentQuestion: {},
      currentIndex: 0,

      dialogStudent: false,
      formLabelWidth: 120,
      studentForm: {
        stuName: "",
        schoolName: "",
        phone: ""
      }
      // studentForm: {
      //   stuName: "小南",
      //   schoolName: "高新一中",
      //   phone: "18888888888"
      // }
    }
  },
  methods: {
    // 获取测试详情
    getTestDetail () {
      request({
        method: 'get',
        url: 'mendao/v2/getTestById',
        params: {
          testId: this.testId
        }
      }).then(res => {
        if (res.code == 0) {
          this.fullscreenLoading = false
          this.testName = res.data.testName
        } else {
          this.$message.error(res.data.message);
        }
      }).catch((res) => {
      });
    },
    // 获取试题列表
    getTopicList () {
      request({
        method: 'get',
        url: 'mendao/v2/getTopicLibrary',
        params: {
          testId: this.testId,
          type: 1
        }
      }).then(res => {
        if (res.code == 0) {
          this.fullscreenLoading = false
          res.data.forEach(e => {
            let tempObj = {
              testId: this.testId,
              topicLibraryName: e.topicLibraryName,
              topicGroupId: e.topicGroupId,
              options: e.options ? JSON.parse(e.options) : [],
            };
            tempObj.options.forEach(option => {
              option.isCheck = false
            })
            this.questionBank.push(tempObj)
          })
          this.currentQuestion = this.questionBank[this.currentIndex];
        } else {
          this.$message.error(res.data.message);
        }
      }).catch((res) => {
      });
    },
    // 操作题目
    handleTopic(topicIndex) {
      for (let i = 0; i < this.currentQuestion.options.length; i++) {
        this.currentQuestion.options[i].isCheck = false;
      }
      this.currentQuestion.options[topicIndex].isCheck = true;
      this.questionBank[this.currentIndex] = this.currentQuestion;
      if (this.currentIndex != this.questionBank.length - 1) {
        setTimeout(e => {
          this.switchTopic(1)
        }, 500)
      }
    },
    // 上一题协议提
    switchTopic(num) {
      let count = 0;
      if (num == 1) {
        for (let i = 0; i < this.currentQuestion.options.length; i++) {
          if(this.currentQuestion.options[i].isCheck == true){
            count++;
          }
        }
        if (count > 0) {
          this.currentIndex += num;
          this.currentQuestion = this.questionBank[this.currentIndex];
        } else {
          if (this.currentIndex != this.questionBank.length - 1) {
            this.$alert('答完本题才能进入下一题哦', '提示', {
              confirmButtonText: '确定',
            });
          }
        }
      } else if (num == -1) {
        if (this.currentIndex > 0) {
          this.currentIndex -= 1
          this.currentQuestion = this.questionBank[this.currentIndex]
        }
      }
    },
    getStudentInfo() {
      this.dialogStudent = true;
    },
    submitStudentInfo() {
      // 校验空，校验手机号
      const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;
      if(!this.studentForm.schoolName) {
        this.$message({
          type: 'warning',
          message: '请输入学校名称!'
        });
        return
      }
      if(!this.studentForm.stuName) {
        this.$message({
          type: 'warning',
          message: '请输入姓名!'
        });
        return
      }
      if (!reg.test(this.studentForm.phone)) {
        this.$message({
          type: 'warning',
          message: '请输入正确的手机号!'
        });
        return
      }
      this.submitAnswer();
    },
    // 提交测评
    submitAnswer () {
      this.dialogStudent = false
      this.fullscreenLoading = true
      let params = {
        testId: this.testId,
        list: []
      }
      this.questionBank.forEach(e => {
        e.options.forEach(option => {
          if (option.isCheck) {
            let tempObj = {
              score: option.optionScore,
              topicGroupId: e.topicGroupId
            };
            params.list.push(tempObj);
          }
        })
      })
      params = Object.assign(params, this.studentForm)
      // return
      // params = {"testId":"1","list":[{"score":"1","topicGroupId":"1_0005"},{"score":"0","topicGroupId":"1_0004"},{"score":"0","topicGroupId":"1_0002"},{"score":"0","topicGroupId":"1_0006"},{"score":"0","topicGroupId":"1_0002"},{"score":"1","topicGroupId":"1_0002"},{"score":"1","topicGroupId":"1_0003"},{"score":"1","topicGroupId":"1_0004"},{"score":"1","topicGroupId":"1_0004"},{"score":"0","topicGroupId":"1_0006"},{"score":"1","topicGroupId":"1_0003"},{"score":"0","topicGroupId":"1_0003"},{"score":"0","topicGroupId":"1_0001"},{"score":"1","topicGroupId":"1_0001"},{"score":"1","topicGroupId":"1_0005"},{"score":"1","topicGroupId":"1_0004"},{"score":"0","topicGroupId":"1_0001"},{"score":"0","topicGroupId":"1_0001"},{"score":"1","topicGroupId":"1_0002"},{"score":"0","topicGroupId":"1_0006"},{"score":"0","topicGroupId":"1_0006"},{"score":"0","topicGroupId":"1_0006"},{"score":"1","topicGroupId":"1_0005"},{"score":"0","topicGroupId":"1_0004"},{"score":"1","topicGroupId":"1_0001"},{"score":"0","topicGroupId":"1_0005"},{"score":"1","topicGroupId":"1_0003"},{"score":"0","topicGroupId":"1_0003"},{"score":"0","topicGroupId":"1_0003"},{"score":"0","topicGroupId":"1_0002"},{"score":"1","topicGroupId":"1_0002"},{"score":"0","topicGroupId":"1_0006"},{"score":"1","topicGroupId":"1_0005"},{"score":"1","topicGroupId":"1_0004"},{"score":"1","topicGroupId":"1_0004"},{"score":"1","topicGroupId":"1_0005"},{"score":"1","topicGroupId":"1_0005"},{"score":"1","topicGroupId":"1_0001"},{"score":"1","topicGroupId":"1_0001"},{"score":"1","topicGroupId":"1_0002"},{"score":"1","topicGroupId":"1_0002"},{"score":"0","topicGroupId":"1_0006"},{"score":"0","topicGroupId":"1_0006"},{"score":"1","topicGroupId":"1_0003"},{"score":"1","topicGroupId":"1_0005"},{"score":"0","topicGroupId":"1_0004"},{"score":"1","topicGroupId":"1_0001"},{"score":"1","topicGroupId":"1_0001"},{"score":"1","topicGroupId":"1_0004"},{"score":"1","topicGroupId":"1_0005"},{"score":"0","topicGroupId":"1_0003"},{"score":"1","topicGroupId":"1_0003"},{"score":"0","topicGroupId":"1_0002"},{"score":"1","topicGroupId":"1_0006"},{"score":"0","topicGroupId":"1_0002"},{"score":"0","topicGroupId":"1_0006"},{"score":"0","topicGroupId":"1_0003"},{"score":"0","topicGroupId":"1_0005"},{"score":"0","topicGroupId":"1_0001"},{"score":"0","topicGroupId":"1_0004"}],"stuName":"小南","schoolName":"高新一中","phone":"18888888888"}
      request({
        method: 'post',
        url: 'mendao/v2/commitTest',
        data: params
        // data: JSON.stringify(params)
      }).then(res => {
        if (res.code == 0) {
          this.fullscreenLoading = false
          this.$message({
            type: 'success',
            message: '成功!'
          });
          setTimeout(() => {
            this.$router.push({
              path: "/evaluation/result",
              query: {
                testId: this.testId,
                id: res.data.id
              }
            });
          }, 1000)
        } else {
          this.$message.error(res.data.message);
        }
      }).catch((res) => {
      });
    },
    // 返回
    goBack () {
      this.$confirm('未完成测试将不会保存测评结果?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.go(-1)
      }).catch(() => {

      });
    },
  },
  created () {
    this.fullscreenLoading = false
    this.testId = this.$route.query.testId
    this.getTestDetail()
    this.getTopicList()
  }
}
</script>

<style lang="stylus">
.evaluation-detail
  .right-btn-box
    .el-button
      width: 60px;
      height: 60px;
      padding: 0;
      margin-bottom: 20px;
      text-align center
      color: #fff;
    .el-button+.el-button
      margin-left: 0;
</style>
<style scoped lang="stylus">
pageWidth = 1440px
$color-background = #fff
$color-background-d = rgba(0, 0, 0, 0.3)
$color-highlight-background = #333
$color-dialog-background = #666
$color-theme = #e96558
$color-theme-d = rgba(233, 101, 88, 0.5)

$color-text = #fff
$color-text-e = rgba(0, 0, 0, 0.1)
$color-text-d = rgba(0, 0, 0, 0.3)
$color-text-l = rgba(0, 0, 0, 0.5)
$color-text-ll = rgba(0, 0, 0, 0.8)

//字体定义规范
$font-size-small-s = 10px
$font-size-small = 12px
$font-size-medium = 14px
$font-size-medium-x = 16px
$font-size-large = 18px
$font-size-large-l = 20px
$font-size-large-x = 22px

div
  box-sizing: border-box
.evaluation-detail
  position relative
  width pageWidth
  min-height 100%
  margin 0 auto
  text-align center
  display flex
  flex-direction column
  align-items center
  justify-content center
  background #fff

  .answer-section
    width: 1000px
    margin 0 auto

    .test-title
      font-size $font-size-large-l
      color $color-text-ll
      font-weight 600
      text-align center

    .test-arrow
      color $color-text-d

    .test-schedule
      color #333
      font-size 15px

    .test-section
      text-align left
      padding 40px 0
      color $color-text-ll

      .topic
        padding-bottom: 40px
        font-size $font-size-large-l
        line-height 40px
        font-weight 600
        text-align center

      .options-box
        display flex
        justify-items: center;
        justify-content: center;
        align-items: center;
        cursor pointer
        width 1000px
        margin 0 auto

        .option-content
          //flex 1
          padding-left 30px
          padding-right 30%
          font-size $font-size-large
          line-height 32px
          font-weight 600
          &.checked
            color: $color-theme

        .option-choose
          display: flex;
          align-items: center;
          width: 18px;
          height: 18px;
          font-size 16px
          border: 1px solid #666666;
          border-radius: 4px;

          &.checked
            color: #fff;
            border: 1px solid $color-theme;

            i
              color: $color-theme;

      .color-main
        color $color-theme

    .test-operate
      text-align center


  .right-btn-box
    position: fixed;
    top: 50%;
    margin-top: -120px;
    right: 10px;
    width: 60px;
</style>
